export default __webpack_public_path__ + "media/images/features/yado/next_pc-5ef3d861883547145315d58ff2d345c2.png";